export default async function ({ store, i18n, $getDomain }: any): Promise<void> {
	const default_per_domain = {
		at: 'de-AT',
		de: 'de-AT',
		cz: 'cs-CZ',
		hu: 'hu-HU',
		sk: 'sk-SK'
	} as any;

	const domain = $getDomain().toLowerCase();
	const locale = default_per_domain[domain];
	const [lang, bu] = default_per_domain[domain].split('-');

	const loaded_trans_keys = Object.keys(i18n.messages);
	const is_already_loaded = loaded_trans_keys.includes(locale) && typeof i18n.messages[locale] !== 'boolean';

	if (!is_already_loaded) {
		const translation = await store.dispatch('GET_TRANSLATION', {
			lang: lang,
			bu: bu.toLowerCase()
		});

		if (translation) {
			i18n.setLocaleMessage(locale, translation);

			const meta = translation?.meta;

			if (meta) {
				const country = i18n.t(`countries.${domain}`, locale);
				const usageRulesTitle = i18n.t('usage_rules.title', locale, { country });

				const additionalMeta = {
					login: {
						title: i18n.t('actions.login', locale),
						mainDesc: i18n.t('actions.login', locale),
						desc: i18n.t('actions.login', locale)
					},
					signup: {
						title: i18n.t('actions.signup', locale),
						mainDesc: i18n.t('actions.signup', locale),
						desc: i18n.t('actions.signup', locale)
					},
					usagerules: {
						title: usageRulesTitle,
						mainDesc: usageRulesTitle,
						desc: usageRulesTitle
					},
					upsells1: {
						title: i18n.t('upsells.packages.meta_title', locale),
						mainDesc: i18n.t('upsells.packages.meta_title', locale),
						desc: i18n.t('upsells.packages.meta_title', locale)
					},
					damageinfo: {
						title: i18n.t('damage_page.main_title', locale),
						mainDesc: i18n.t('damage_page.main_title', locale),
						desc: i18n.t('damage_page.main_title', locale)
					},
					ourapp: {
						title: i18n.t('app_infopage.how_section.title', locale),
						mainDesc: i18n.t('app_infopage.how_section.title', locale),
						desc: i18n.t('app_infopage.how_section.title', locale)
					}
				};

				store.dispatch('GENERATE_META_DATA', { ...meta, ...additionalMeta });
			}

			// Store in VUEX to then merge current locale into it
			// tmp disable to check effects
			// store.commit('storeTranslation', translation);
			i18n.setLocaleMessage(locale, translation);
		}
	}
}
